import { useEffect, useRef } from 'react';

const parseSummaryToSets = (summary) =>
  (summary || []).reduce((legIdSet, summary, legId) => {
    return summary.isApplied ? legIdSet.add(legId) : legIdSet;
  }, new Set());

const fromDiffSetToChanges = (previous, next, tag) => {
  const tags = new Set([...previous, ...next]);
  const changes = [];
  const createAction = (type, legId) => ({
    type,
    tag: {
      legId,
      ...tag,
    },
  });
  for (const legId of tags) {
    if (previous.has(legId) && !next.has(legId)) {
      changes.push(createAction('REMOVE', legId));
    } else if (!previous.has(legId) && next.has(legId)) {
      changes.push(createAction('ADD', legId));
    }
  }
  return changes;
};

export const useDiff = (next) => {
  const previousRef = useRef();
  useEffect(() => {
    previousRef.current = next;
  });
  const previous = previousRef.current;
  return {
    previous,
    next,
  };
};

export const fromSummaryDiffToChanges = (previous, next, alias, undo, type) => {
  const previousLegIds = parseSummaryToSets(previous);
  const nextLegIds = parseSummaryToSets(next);
  return fromDiffSetToChanges(previousLegIds, nextLegIds, {
    alias,
    undo,
    type,
  });
};
